import "core-js/modules/es.error.cause.js";
import { mapState } from 'vuex';
import { editPersonalInformationCustomer, editPersonalInformation } from './request';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        userId: '',
        nickName: '',
        account: '',
        email: ''
      },
      confirmLoading: false,
      env: process.env.NODE_ENV
    };
  },
  computed: {
    visibleModal: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    ...mapState({
      accountInfo: state => state.user.accountInfo
    }),
    rules() {
      return {
        nickName: [{
          required: true,
          message: this.$t('请输入') + this.$t('管理员名称'),
          trigger: 'blur'
        }],
        account: [{
          required: true,
          message: this.$t('请输入账号'),
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9@.]+$/,
          message: this.$t('仅限输入大小写字母、数字、特殊符号“@”和“.”'),
          trigger: 'blur'
        }, {
          min: 8,
          max: 50,
          message: this.$t('请输入8-50字符'),
          trigger: 'blur'
        }],
        email: [{
          required: false,
          validator: this.checkEmail,
          trigger: 'blur'
        }]
      };
    },
    diabledEditName() {
      return this.accountInfo.customerId === 490 && this.env === 'development' || this.accountInfo.customerId === 119 && this.env === 'production';
    }
  },
  mounted() {
    console.log(this.accountInfo, 'store this.accountInfo');
    this.form = {
      userId: this.accountInfo.id,
      nickName: this.accountInfo.nickName,
      account: this.accountInfo.account,
      email: this.accountInfo.email
    };
  },
  methods: {
    checkEmail(rule, value, callback) {
      let regEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (value && !regEmail.test(value)) {
        callback(new Error(this.$t('邮箱有误，请重新填写')));
      } else {
        callback();
      }
    },
    handleBlurTrim(key) {
      this.form[key] = this.form[key].trim();
    },
    confirmModal() {
      this.$refs.editPersonInfoRef.validate(async valid => {
        if (valid) {
          this.confirmLoading = true;
          if (this.accountInfo.customerId > 0) {
            // 客户端
            await editPersonalInformationCustomer(this.form).then(res => {
              if (res) {
                // 重新获取用户信息
                this.$store.dispatch('user/getInfo');
                this.$message.success(this.$t('个人信息修改成功'));
                this.visibleModal = false;
                this.confirmLoading = false;
              }
            }).catch(err => {
              this.confirmLoading = false;
            });
          } else {
            // 总系统
            await editPersonalInformation(this.form).then(res => {
              if (res) {
                // 重新获取用户信息
                this.$store.dispatch('user/getInfo');
                this.$message.success(this.$t('个人信息修改成功'));
                this.visibleModal = false;
                this.confirmLoading = false;
              }
            }).catch(err => {
              this.confirmLoading = false;
            });
          }
        }
      });
    },
    cancelModal() {
      // 重置form
      this.$refs.editPersonInfoRef.resetFields();
      this.visibleModal = false;
      this.confirmLoading = false;
    }
  }
};